<template>
  <Tabs :animated="false"
        :value="selectTabName"
        @on-click="handleTabClick">
    <PaymentTab
      key="balance"
      type="balance"
      :users="users"
      :flagList="balanceFlagList"
      :editable="editable"
      @on-loading="updateLoading"
      @on-update-item="(item, isChanged) => $emit('on-update-item', item, isChanged, 'balance')">
    </PaymentTab>
    <PaymentTab
      key="billing"
      :users="users"
      :flagList="billingFlagList"
      :editable="editable"
      @on-loading="updateLoading"
      @on-update-item="(item, isChanged) => $emit('on-update-item', item, isChanged, 'billing')">
    </PaymentTab>
  </Tabs>
</template>

<script>
import PaymentTab from './paymentTab.vue';

export default {
  name: 'payment-component',
  components: {
    PaymentTab,
  },
  props: {
    // pass updated data once saved
    balanceFlagList: {
      type: Array,
      default() {
        return []
      }
    },
    billingFlagList: {
      type: Array,
      default() {
        return []
      }
    },
    editable: false,
    users: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      selectTabName: '0',
    };
  },
  methods: {
    handleTabClick(name) {
      this.selectTabName = name;
    },
    updateLoading(val) {
      this.$emit('on-loading', val);
    }
  },
};
</script>

<style lang="less">
.paymentc{
    &__filter{
      padding: 0 16px 22px;
      .ivu-col{
        position: relative;
      }
      .label{
        color: rgba(0, 0, 0, 0.87);
        position: absolute;
        left: 16px;
        top: 6px;
        font-weight: 500;
        z-index: 1;
      }
      .ivu-input{
        border-radius: 8px;
        color: rgba(0, 0, 0, 0.87);
        font-weight: 500;
        border-color: rgba(0, 0, 0, 0.08);
        box-shadow: none;
      }
      .ivu-select{
        color: rgba(0, 0, 0, 0.87);
        font-weight: 500;
        position: relative;
        z-index: 2;
      }
      .ivu-select-selection{
        border-radius: 8px;
        border-color: rgba(0, 0, 0, 0.08);
        padding-left: 70px;
        box-shadow: none;
        background-color: transparent;
      }
    }
    &__body{
      padding: 0 16px;
      &.no-data{
        padding-top: 150px;
      }
    }
    &__main{
      height: 100%;
      overflow: auto;
      position: relative;
    }
  }

  .ivu-tabs{
    height: calc(100% - 60px);
    position: relative;
  }
  .ivu-tabs-bar{
    margin-bottom: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }
  .ivu-tabs-ink-bar{
    height: 3px;
  }
  .ivu-tabs-nav{
    .ivu-tabs-tab{
      padding: 13px 24px;
      font-weight: 500;
    }
  }
  .ivu-tabs-nav-wrap{
    margin-bottom: 0;
  }
  .ivu-tabs-content{
    height: calc(100% - 48px);
    overflow: hidden;
    padding: 16px 0;
  }
  .ivu-tabs-tabpane{
    height: 100%;
  }
</style>